<template>
  <Authentication>
    <phone-step-1
      @setForm="setForm"
      :step="step"
      v-if="step === 1"
      @next="next"
    />
    <phone-step-2
      @setForm="setForm"
      :step="step"
      :mainForm="form"
      v-else-if="step === 2"
      @prev="prev"
    />
  </Authentication>
</template>

<script>
import Authentication from "../Authentication";
import PhoneStep1 from "./PhoneStep1.vue";
import PhoneStep2 from "./PhoneStep2.vue";
export default {
  components: {
    Authentication,
    PhoneStep1,
    PhoneStep2
  },
  data() {
    return {
      form: {
        phone: { value: "", error: "" },
        verifyCode: { value: "", error: "" },
        password: { value: "", error: "" },
        confirmPassword: { value: "", error: "" }
      },
      step: 1
    };
  },
  methods: {
    next: function() {
      this.step = this.step >= 1 ? 2 : this.step + 1;
    },
    prev: function() {
      this.step = this.step <= 1 ? 1 : this.step - 1;
    },
    setForm: function(form) {
      this.form = { ...this.form, ...form };
    }
  }
};
</script>

<style></style>
